import { createContext, useContext, useEffect, useState } from "react";
import stompClient from "./stompClient";
import stompClientMP from "./stompClientMP";
import TypeMessagesRMQ from "../constants/TypeMessagesRMQ";

const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ idPlayer, children }) => {
  //#region RABBITMQ
  const [lastMessagePublisher, setLastMessagePublisher] = useState([]);
  const [entriesMessageRMQ, setEntriesMessageRMQ] = useState([]);
  const [raceCreateMessageRMQ, setRaceCreateMessageRMQ] = useState([]);
  const [entryCreateMessageRMQ, setEntryCreateMessageRMQ] = useState([]);
  const [lastMessage, setLastMessage] = useState({
    MessageType: "",
    Message: "No message received yet",
  });
  const [selectOption, setSelectOption] = useState({
    trackID: 0,
    trackName: "",
    raceID: 0,
    raceNumber: 0,
    trackCode: "",
    raceStatus: "",
    statusTrackCollapsed: "",
  });
  //STOMPCLIENT
  useEffect(() => {
    stompClient.onConnect = () => {
      stompClient.subscribe(
        "/exchange/" + window.config.RMQConfig.Exchange,
        (message) => {
          const obj = JSON.parse(message.body);
          if (obj.MessageType === TypeMessagesRMQ.EntryChange.name) {
            if (selectOption.raceID && selectOption.raceID === obj.RaceID) {
              setEntriesMessageRMQ((prevState) => [obj, ...prevState]);
            }
          } else if (obj.MessageType === TypeMessagesRMQ.RaceCreate.name) {
            setRaceCreateMessageRMQ((prevState) => [obj, ...prevState]);
          } else if (obj.MessageType === TypeMessagesRMQ.EntryCreate.name) {
            setEntryCreateMessageRMQ((prevState) => [obj, ...prevState]);
          } else {
            setLastMessage(obj);
          }
        }
      );
    };

    stompClient.activate();

    return () => {
      stompClient.deactivate();
    };
  }, []);

  //STOMPCLIENTMP
  useEffect(() => {
    stompClientMP.onConnect = () => {
      stompClientMP.subscribe(
        "/queue/" +
          window.config.RMQMessagePublisherConfig.DefaultQueue +
          "." +
          idPlayer,
        (message) => {
          const obj = JSON.parse(message.body);
          setLastMessagePublisher((prevState) => [obj, ...prevState]);
        }
      );
    };

    stompClientMP.activate();

    return () => {
      stompClientMP.deactivate();
    };
  }, []);

  return (
    <WebSocketContext.Provider
      value={{
        lastMessagePublisher,
        setLastMessagePublisher,
        entriesMessageRMQ,
        setEntriesMessageRMQ,
        raceCreateMessageRMQ,
        setRaceCreateMessageRMQ,
        entryCreateMessageRMQ,
        setEntryCreateMessageRMQ,
        lastMessage,
        setLastMessage,
        selectOption,
        setSelectOption,
      }}
    >
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocket = () => {
  const context = useContext(WebSocketContext);
  if (!context) {
    console.warn("useWebSocket must be used within a WebSocketProvider");
    return {
      lastMessage: { MessageType: "", Message: "No provider detected" },
    };
  }
  return context;
};
